/*
 * @Description:
 * @Author: Rieko
 * @LastEditors: Rieko
 * @PersonalStation:
 * @Date: 2022-05-04 15:03:09
 * @LastEditTime: 2022-05-04 15:03:47
 */
const ADD = 'ADD';
const EDIT = 'EDIT';

export { ADD, EDIT };
